module.exports = __webpack_public_path__ + "static/capitol-c042704d988e82c56e7bb693cb634211.jpg";